// extracted by mini-css-extract-plugin
export default {"card":"s4-z"};